import gsap from "gsap";

const preloader = document.querySelector('.preloader');
const preloaderPaths = document.querySelectorAll('.site-logo path');
const siteContent = document.querySelector('.site-content');

export default {
  init: () => {
    gsap.set(siteContent, {
      y: "100%",
      opacity: 1,
    });

    const timeline = gsap.timeline();

    timeline
    .from(preloaderPaths, {
      y: '100%',
      duration: 0.6,
      ease: "power1.out",
      stagger: 0.1,
    })
    .to(preloaderPaths, {
      y: "-110%",
      duration: 0.5,
      stagger: 0.05,
      delay: 0.6,
      ease: "power1.out",
    })
    .to(preloader, {
      y: "-100%",
      duration: 1,
      ease: "circ.out",
    })
    .to(siteContent, {
      y: "0%",
      opacity: 1,
      duration: 1.8,
      ease: "power3.out",
    }, '<-0.4')
    .fromTo(preloader, {
      background: "linear-gradient(100deg, rgba(153,61,234,1) 0%, rgba(202,142,255,1) 100%)",
    }, {
      background: "#0F0E0F",
      duration: 2.5,
      delay: 1,
      ease: "power4.out",
    }, 0);

    timeline.add(() => preloader.remove());
  }
};
